import { LessonTask, LessonStep } from '../../../types/asset/lesson.types.ts';
import { ScriptProcessingResult, SpeakableScriptPartType } from '../../../types/asset/script.types.ts';

import { getLessonsUtil } from '../lessons.util.ts';
import { getLettersUtil } from '../letters.util.ts';

import { BaseScriptsProcessor } from './base-scripts-processor.ts';

/**
 * This processor is used to process the letter part of a script: "\\(letter.file)"
 */
export class ScriptsFileLetterProcessor extends BaseScriptsProcessor {
  public process(part: string, task: LessonTask, step: LessonStep): ScriptProcessingResult {
    if (part.startsWith('\\(') && part.endsWith('.file)')) {
      const partKey = part.slice(2, -6);
      if (partKey === 'letter') {
        // In this case we want to return the current step letter as a letter
        const letter = getLessonsUtil().getStepLetter(task, step);
        if (letter) {
          return { parts: [{ letter, type: SpeakableScriptPartType.Letter }], processed: true };
        } else {
          this.handleError(new Error('No letter found'), task, step);
          return { parts: [], processed: true };
        }
      } else if (partKey === 'rhymingSounds') {
        // In this case we want to return the current step rhyming sound as a letter
        const rhymingSoundKey = task.rhymingSounds?.[step.index ?? 0];
        const rhymingSoundLetter = rhymingSoundKey ? getLettersUtil().getLetter(rhymingSoundKey) : null;
        if (rhymingSoundLetter) {
          return {
            parts: [{ letter: rhymingSoundLetter.appearance, type: SpeakableScriptPartType.Letter }],
            processed: true,
          };
        } else {
          this.handleError(new Error('No letter found'), task, step);
          return { parts: [], processed: true };
        }
      }
    }
    return { parts: [], processed: false };
  }
}
